import { Helmet } from 'react-helmet-async';
import BrandInfringementView from 'src/sections/overview/dashboards/views/brand-shield/brand-infringement';

export default function BrandShieldInfringement() {
  return (
    <>
      <Helmet>
        <title>Brand Infringement</title>
      </Helmet>
      <BrandInfringementView />
    </>
  );
}
